import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getActivityByUserID } from '../../../actions/activityActions'
import { Card } from '@material-ui/core'
import Loader from '../../Loader/Loader'
import ActivityItem from '../../Activity/ActivityItem'
import Message from '../../Message/Message'

const Activity = () => {
  const dispatch = useDispatch()

  const { userInfo } = useSelector((state) => state.userLogin)
  const { activities, loading, error } = useSelector(
    (state) => state.activityList
  )

  useEffect(() => {
    dispatch(getActivityByUserID())
  }, [dispatch, userInfo])

  return (
    <Card className="activities">
      <div className="header">
        <h5 className="fs16 m-b-0">Activity</h5>
      </div>
      <div id="activity-list" className="scrollable">
        {loading && <Loader />}

        {!loading &&
          activities &&
          activities.length > 0 &&
          activities.map((item, index) => (
            <ActivityItem key={index} item={item} isDashboard={true} />
          ))}

        {error && <Message variant="danger p-16">{error}</Message>}
      </div>
    </Card>
  )
}

export default Activity
